import React from 'react';

function SunneySolution() {
    return(
        <section class="sunney-solution">
        <h2>The Solution:</h2>
        <p>I designed a mobile application where graduating seniors and juniors can focus on providing a break from 
            academic pressures and offering opportunities for self-expression and interest exploration.
        </p>
    </section>

    );
}

export default SunneySolution;